function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h11v6H0zM0 9h11v6H0zM0 18h11v6H0zM14 0h12v6H14zM14 9h12v6H14zM14 18h12v6H14z"
}));

var SvgGrid = function SvgGrid(props) {
  return React.createElement("svg", _extends({
    width: 26,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI2IDI0Ij48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4xMzQgMC40OTgpIj48cmVjdCB3aWR0aD0iMTEiIGhlaWdodD0iNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4xMzQgLTAuNDk4KSIgZmlsbD0iY3VycmVudENvbG9yIi8+PHJlY3Qgd2lkdGg9IjExIiBoZWlnaHQ9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMTM0IDguNTAyKSIgZmlsbD0iY3VycmVudENvbG9yIi8+PHJlY3Qgd2lkdGg9IjExIiBoZWlnaHQ9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMTM0IDE3LjUwMikiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC4xMzQgLTAuNDk4KSIgZmlsbD0iY3VycmVudENvbG9yIi8+PHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjEzNCA4LjUwMikiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxyZWN0IHdpZHRoPSIxMiIgaGVpZ2h0PSI2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC4xMzQgMTcuNTAyKSIgZmlsbD0iY3VycmVudENvbG9yIi8+PC9nPjwvc3ZnPgo=";
export { SvgGrid as ReactComponent };